import { PessoaBaseModel } from '../../../core/models/pessoa.model';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { EnumDataset } from '../../../core/enums/enum-dataset';
import { getEnumValues } from '../../../core/tools/helper.tools';
import { EnumSimNao } from '../../../core/enums/enum-simnao';
import { EnumSistemas } from '../../../core/enums/enum-sistemas';
import { SpeedDialModule } from 'primeng/speeddial';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TagModule } from 'primeng/tag';
import { TitleComponent } from '../../../core/componentes/Title/title.component';
import { SistemaService } from '../service/sistema.service';
import { ListarSistemasModel } from '../models/listar-sistemas.model';
import { VoltarComponent } from '../../../core/componentes/voltar/voltar.component';
import { FuncionalidadeModel } from '../models/funcionalidade.model';
import { InputNumberModule } from 'primeng/inputnumber';
import { DialogModule } from 'primeng/dialog';
@Component({
  selector: 'app-sistema',
  templateUrl: './sistemas.gestao.html',
  styleUrl: './sistemas.gestao.scss',
  standalone: true,
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule,
    InputTextModule,
    FloatLabelModule,
    ReactiveFormsModule,
    DropdownModule,
    InputMaskModule,
    SpeedDialModule,
    TableModule,
    ToastModule,
    TagModule,
    TitleComponent,
    VoltarComponent,
    InputNumberModule,
    DialogModule,
  ],
})
export class SistemaGestao implements OnInit {
  public translate = inject(TranslateService);
  constructor(private formBuilder: FormBuilder, private router: Router) {}

  //#region Service
  sistemaService = inject(SistemaService);
  route = inject(ActivatedRoute);

  //#endregion

  //#region Inicialização
  token: string = sessionStorage.getItem(EnumDataset.dataSetLogin) || '';
  value: string = '';
  formBuscarFuncionalidade: FormGroup = this.initFormularioFuncionalidade();
  formAddEditarFuncionalidade: FormGroup =
    this.initFormularioAddEditarFuncionalidade();
  sistemasConst = getEnumValues(EnumSistemas);
  sistema: ListarSistemasModel = {
    id: 0,
    nome: '',
    aplicacao: 0,
  };

  funcionalidades: FuncionalidadeModel[] = [];
  showAddFuncionalidade: boolean = false;
  showEditarFuncionalidade: boolean = false;

  showAddFuncionalidadeDialog() {
    this.showAddFuncionalidade = true;
  }
  showEditarFuncionalidadeDialog(funcionalidade: FuncionalidadeModel) {
    this.formAddEditarFuncionalidade.patchValue(funcionalidade);
    this.showEditarFuncionalidade = true;
  }

  limparFormularioFuncionalidade() {
    this.formAddEditarFuncionalidade =
      this.initFormularioAddEditarFuncionalidade();
    this.showEditarFuncionalidade = false;
  }

  initFormularioFuncionalidade() {
    this.formBuscarFuncionalidade = this.formBuilder.group({
      id: null,
      nome: null,
      aplicacao: null,
      descricao: null,
      valor: null,
    });
    return this.formBuscarFuncionalidade;
  }
  initFormularioAddEditarFuncionalidade() {
    this.formAddEditarFuncionalidade = this.formBuilder.group({
      id: null,
      nome: null,
      aplicacao: null,
      descricao: null,
      valor: null,
      nomeController: null,
      nomeAction: null,
    });

    return this.formAddEditarFuncionalidade;
  }

  ngOnInit() {
    var sistemaId = 0;
    this.route.paramMap.subscribe((params) => {
      sistemaId = +params.get('id')!; // Obtém o valor do parâmetro 'id'
    });

    this.buscarSistema(sistemaId);
  }

  buscarSistema(sistemaId: number) {
    this.sistemaService.buscarSistemaPorId(sistemaId).then((res) => {
      this.sistema = res;
      this.buscarFuncionalidades();
    });
  }

  buscarFuncionalidades() {
    const filtros = this.formBuscarFuncionalidade.value;
    filtros.aplicacao = this.sistema.aplicacao;

    // Dados iniciais (seu mock de exemplo)
    this.sistemaService.buscarFuncionalidades(filtros).then((data) => {
      this.funcionalidades = data;
    });
  }

  //#endregion

  //#region Actions

  salvarSistema() {
    var formulario = this.formBuscarFuncionalidade.value;

    this.sistema.nome = formulario.nome;
    this.sistema.aplicacao = formulario.aplicacao;
    this.sistema.id = formulario.id;

    this.sistemaService.salvarSistema(this.sistema);
  }

  salvarFuncionalidade() {
    var formulario = this.formAddEditarFuncionalidade.value;
    formulario.aplicacao = this.sistema.aplicacao;
    this.sistemaService.salvarFuncionalidade(formulario as FuncionalidadeModel);
  }
  salvarEditarFuncionalidade() {
    var formulario = this.formAddEditarFuncionalidade.value;
    formulario.aplicacao = this.sistema.aplicacao;
    this.sistemaService.salvarEditarFuncionalidade(
      formulario as FuncionalidadeModel
    );
    this.formAddEditarFuncionalidade =
      this.initFormularioAddEditarFuncionalidade();
  }

  //#endregion
}
